export default {
  ROOT_URL: 'https://testing.conversional.de',
  GA_ID: '',
  WS_URL: 'soketi-k8s.conversional.de',
  // STUDIO_URL: "https://studio-dot-conversional-testing-v3.ew.r.appspot.com/",
  STUDIO_URL: 'https://studio-testing.conversional.de/',
  sentry:
    'https://6a99474d26cb411395b5f81a07eba4c8@o236458.ingest.sentry.io/1452146',
};
